import { MessageCircle, ExternalLink, Flame } from 'lucide-react';

export default function CTASection() {
  return (
    <section className="relative py-16 md:py-24 overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://storage.readdy-site.link/project_files/2d00fbf4-9726-483a-b70b-ea6e421eb3f8/e876a971-75e8-46e4-8be9-b93135b9bebf_compressed_Captura-de-tela-2026-07-21-164608.webp"
          alt="Comida baiana do Buteco do Baiano"
          className="w-full h-full object-cover object-center"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/60 to-black/75"></div>
      </div>

      <div className="relative z-10 w-full px-4 sm:px-6 lg:px-10 xl:px-16">
        <div className="max-w-3xl mx-auto text-center reveal">
          <span className="inline-flex items-center justify-center gap-2 text-yellow-400 text-xs font-semibold tracking-widest uppercase mb-4">
            <Flame size={16} className="text-yellow-400" />
            VEM PRO BUTECO
            <Flame size={16} className="text-yellow-400" />
          </span>
          <h2 className="font-heading text-3xl sm:text-4xl md:text-5xl font-bold text-white leading-tight mb-6">
            Bora sentir o clima baiano na <span className="text-yellow-400">Varjota</span>?
          </h2>
          <p className="text-white/80 text-base md:text-lg max-w-xl mx-auto mb-10 leading-relaxed">
            Fale com o Buteco do Baiano pelo WhatsApp, consulte o menu e venha aproveitar petiscos, drinks, música e culinária nordestina em Fortaleza.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="https://wa.me/5585987413961?text=Olá!%20Vim%20pelo%20site%20do%20Buteco%20do%20Baiano%20e%20gostaria%20de%20mais%20informações."
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-8 py-3.5 bg-yellow-500 text-white font-semibold rounded-full hover:bg-yellow-600 transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap"
            >
              <MessageCircle size={20} />
              Fazer sua reserva
            </a>
            <a
              href="https://playmenu.app/public/index.php?r=buteco-do-baiano&from=admin"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-8 py-3.5 bg-white/10 backdrop-blur-sm border border-white/20 text-white font-semibold rounded-full hover:bg-white/20 transition-all duration-300 whitespace-nowrap"
            >
              <ExternalLink size={18} />
              Ver cardápio
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}